import { createStore, compose, applyMiddleware } from 'redux'
import {
  generalSocketMiddleware
} from 'shared/middlewares'
import rootReducer from 'state/reducers'
import rootSaga from 'state/saga'
import createSagaMiddleware from 'redux-saga'

const sagaMiddleware = createSagaMiddleware({
  // Catch errors during saga execution
  onError: err => {
    console.error('Uncaught error from Sagas', err, err.stack)
  }
})

const middleware = [
  sagaMiddleware,
  generalSocketMiddleware
]

const store = createStore(rootReducer, {}, compose(
  applyMiddleware(...middleware),
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
))

// Start root saga
sagaMiddleware.run(rootSaga)

export default store
